// extracted by mini-css-extract-plugin
module.exports = {"fileIcon":"Thumbnail_fileIcon__1TJrA"};